$('#collection-filter-drawer').click(function() {
  addItemSizeLine();
})

$('.ProductItem__ColorSwatchList .ColorSwatch__Radio').removeAttr('checked').prop('checked', false).change();
$('.ProductItem__ColorSwatchList .SizeSwatch__Radio').removeAttr('checked').prop('checked', false).change();

setTimeout(function(){
$('.ProductForm__Variants .ColorSwatch__Radio:checked').trigger('click');
},100);

function addSizeLine(color){

  $($('.ProductForm__Variants .SizeSwatchList .HorizontalList__Item').get().reverse()).each(function(i,e){
    var class_name = $(e).attr('class').replace(/\s+/g,'#');
    var class_arr = class_name.split('#');

    for (i = 0; i < class_arr.length; i++) {
      if ( class_arr[i] == color){
        $(e).removeClass('add_diagonal_line');
        break;
      } else {
        $(e).addClass('add_diagonal_line');
      }
      }
    })
    
  if ($('.ProductForm__Variants .SizeSwatch__Radio:checked').parent().attr('class').indexOf( color ) == -1 ) {
    $($('.ProductForm__Variants .SizeSwatchList .HorizontalList__Item').get().reverse()).each(function(i,e){
    var class_name = $(e).attr('class').replace(/\s+/g,'#');
    var class_arr = class_name.split('#');

    for (i = 0; i < class_arr.length; i++) {
      if ( class_arr[i] == color){
        $(e).children('.SizeSwatch__Radio').trigger('click');
      }
    }
    })
  }
  color_sale();
  }

function addColorLine(){
      $('.SizeSwatch__Radio:checked').each(function() {
        var size = $(this).val();
        if ( size == 'L' ) {
          size = 'L1';
        }
      var color_class_name = $(this).parent().attr('class');
      if ( color_class_name.indexOf( 'color_sale' ) >= 0 ){
        $(this).parent().removeClass('add_diagonal_line');
      }

      $(this).parent().parent().parent().parent().children('.ProductForm__Option').children('.ColorSwatchList').children('.HorizontalList__Item').each(function(i,e){
        var class_name = $(e).attr('class');
        if ( class_name.indexOf( size ) >= 0){
          $(e).children('.add_opacity').css('display', 'none');
        } else {
          $(e).children('.add_opacity').css('display', 'block');
        }
      })
    })
  }
function color_sale() {
  $('.ColorSwatchList .HorizontalList__Item').each(function(i,e){
    var class_name = $(e).attr('class');
    if ( class_name.indexOf( 'size_sale' ) >= 0){
      $(e).children('.add_opacity').css('display', 'none');
    } else {
      $(e).children('.add_opacity').css('display', 'block');
    }
  })
}

function addItemSizeLine(){
  
    $('.ProductItem__ColorSwatchList .ColorSwatch__Radio:checked').each(function() {
      var color = $(this).val();
      $(this).parent().nextAll().children('.HorizontalList__Item').children('input').removeAttr('checked').prop('checked', false).change();
      var size_class_name = $(this).parent().attr('class');
      if ( size_class_name.indexOf( 'size_sale' ) >= 0 ){
        $(this).nextAll('.add_opacity').css('display', 'none');
      }
      $(this).parent().nextAll().children('.HorizontalList__Item').each(function(i,e){
        //var class_name = $(e).attr('class');
        var class_name = $(e).attr('class').replace(/\s+/g,'#');
        var class_arr = class_name.split('#');

        for (i = 0; i < class_arr.length; i++) {
        if ( class_arr[i] == color){
          $(e).removeClass('add_diagonal_line');
          break;
        } else {
          $(e).addClass('add_diagonal_line');
        }
      }
    })
    })
  color_item_sale();
  }

function addItemColorLine(){
    $('.ProductItem__ColorSwatchList .SizeSwatch__Radio:checked').each(function() {
      var size = $(this).val();
        if ( size == 'L' ) {
          size = 'L1';
        } else if (size == 'S') {
          size = 'S1';
        }
      var color_class_name = $(this).parent().attr('class');
      if ( color_class_name.indexOf( 'color_sale' ) >= 0 ){
        $(this).parent().removeClass('add_diagonal_line');
      }
      $(this).parent().parent().parent().children('.ProductItem__ColorSwatchItem').children('input').removeAttr('checked').prop('checked', false).change();
      $(this).parent().parent().parent().children('.ProductItem__ColorSwatchItem').each(function(i,e){
        
        var class_name = $(e).attr('class');
        if ( class_name.indexOf( size ) >= 0){
          $(e).children('.add_opacity').css('display', 'none');
        } else {
          $(e).children('.add_opacity').css('display', 'block');
        }
      })
    })
  }

function color_item_sale() {
  $('.ProductItem__ColorSwatchItem').each(function(i,e){
    var class_name = $(e).attr('class');
    console.log(class_name);
    if ( class_name.indexOf( 'size_sale' ) >= 0){
      $(e).children('.add_opacity').css('display', 'none');
    } else {
      $(e).children('.add_opacity').css('display', 'block');
    }
  })
}